import type { ProductWithCategories } from '@/lib/api/products';
import scenes from './offer-photo-scenes.json';

interface OfferPhotoScene {
  source_url: string;
  image: string;
  campaign_desktop?: string;
  campaign_mobile?: string;
}

const offerScenes: Readonly<Record<string, OfferPhotoScene>> = scenes;

/** Use an approved scene only for the exact catalog photograph it was made from. */
export function getOfferPhoto(product?: Pick<ProductWithCategories, 'id' | 'image_url'>) {
  if (!product?.image_url) return undefined;
  const scene = offerScenes[String(product.id)];
  return scene?.source_url === product.image_url && scene.image
    ? scene.image
    : product.image_url;
}

/** Campaign covers are valid only while the configured catalog photograph matches. */
export function getOfferCampaign(product?: Pick<ProductWithCategories, 'id' | 'image_url'>) {
  if (!product?.image_url) return undefined;
  const scene = offerScenes[String(product.id)];
  if (scene?.source_url !== product.image_url) return undefined;
  return scene.campaign_desktop || scene.campaign_mobile
    ? { desktop: scene.campaign_desktop, mobile: scene.campaign_mobile }
    : undefined;
}
